import { useState } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { Text } from '@mentimeter/ragnar-ui/text';
import type { QuestionWithSlide } from '@mentimeter/voting-schema/api-types-overrides';
import { StringParser } from '../../ui/Components/StringParserWrapper';

export const VotingForm = ({
  choices,
  onSubmitVote,
}: {
  choices: QuestionWithSlide['choices'];
  onSubmitVote: (choiceId: number) => void;
}) => {
  const [idVoted, setIdVoted] = useState<number | null>(null);

  return (
    <Box width="100%" mt="space8">
      {choices.map((c) => {
        const isSelected = idVoted === c.id;

        return (
          <Clickable
            minHeight="80px"
            bg={isSelected ? 'secondaryWeak' : 'bg'}
            mb="space4"
            type="submit"
            key={c.id}
            py="space4"
            px="space6"
            borderRadius="4xl"
            aria-label={c.label}
            width="100%"
            justifyContent="center"
            borderWidth={isSelected ? '2px' : '1px'}
            borderColor={isSelected ? 'secondary' : 'borderWeak'}
            borderStyle="solid"
            disabled={isSelected}
            onClick={() => {
              setIdVoted(c.id);
              onSubmitVote(c.id);
            }}
          >
            <Text
              textAlign="left"
              fontWeight="semiBold"
              color={isSelected ? 'onSecondaryWeak' : 'text'}
            >
              <StringParser disableLineBreaks source={c.label} />
            </Text>
          </Clickable>
        );
      })}
    </Box>
  );
};
